"use client";

import { motion } from "framer-motion";
import {
    Filter,
    Wrench,
    Hash,
    Shield,
    Zap,
    GitPullRequest
} from "lucide-react";

const guarantees = [
    {
        icon: Filter,
        title: "never comments on formatting-only diffs",
        description: "ignores whitespace changes, import reordering, and cosmetic updates. focuses only on logic and functionality.",
    },
    {
        icon: Wrench,
        title: "every comment includes a concrete fix",
        description: "no vague suggestions. provides specific code changes, examples, and actionable improvements.",
    },
    {
        icon: Hash,
        title: "max 10 comments per pr",
        description: "keeps reviews focused and actionable. prioritizes the most critical issues first.",
    },
    {
        icon: Shield,
        title: "flags only merge-blocking risks by default",
        description: "warns about security vulnerabilities, bugs, and breaking changes. lets style preferences slide.",
    },
    {
        icon: Zap,
        title: "< 1s latency",
        description: "optimized streaming architecture. feedback appears before you context switch.",
    },
    {
        icon: GitPullRequest,
        title: "github native",
        description: "seamless integration. comments appear directly on your prs, just like human reviews.",
    },
];

export function FeatureGrid() {
    return (
        <section className="py-24 px-4 bg-background border-t border-border">
            <div className="container mx-auto max-w-6xl">
                <div className="mb-16 text-center">
                    <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight">
                        burg ai review guarantees
                    </h2>
                    <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
                        trust built through precision. no noise, only signal.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
                    {guarantees.map((guarantee, index) => {
                        const Icon = guarantee.icon;
                        return (
                            <motion.div
                                key={guarantee.title}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                className="h-full"
                            >
                                <div className="p-6 rounded-xl border border-border bg-card hover:border-foreground/20 transition-colors h-full flex flex-col">
                                    <div className="mb-4">
                                        <Icon className="w-5 h-5 text-muted-foreground" />
                                    </div>
                                    <h3 className="text-base font-semibold mb-2">{guarantee.title}</h3>
                                    <p className="text-muted-foreground text-sm leading-relaxed">
                                        {guarantee.description}
                                    </p>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
